import { httpClient } from "../../httpClient";

export async function putEmployeeDelegate(
  employeeDelegateId: number,
  payload: any
): Promise<boolean> {
  try {
    const { data } = await httpClient.put<boolean>(
      `/api/v1/updateemployeedelegate/${employeeDelegateId}`,
      payload
    );

    return data;
  } catch (error) {
    throw error;
  }
}

export async function deleteEmployeeDelegate(
  employeeDelegateId: number
): Promise<boolean> {
  try {
    const { data } = await httpClient.delete<boolean>(
      `/api/v1/deleteemployeedelegate/${employeeDelegateId}`
    );

    return data;
  } catch (e) {
    throw e;
  }
}

export async function postEmployeeDelegate(
  employeeId: number,
  payload: any
): Promise<boolean> {
  try {
    const { data } = await httpClient.post<boolean>(
      `/api/v1/createemployeedelegate/${employeeId}`,
      payload
    );

    return data;
  } catch (e) {
    throw e;
  }
}
